import { render, staticRenderFns } from "./VoiceRoomChat.vue?vue&type=template&id=57012017&scoped=true"
import script from "./VoiceRoomChat.vue?vue&type=script&lang=js"
export * from "./VoiceRoomChat.vue?vue&type=script&lang=js"
import style0 from "./VoiceRoomChat.vue?vue&type=style&index=0&id=57012017&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57012017",
  null
  
)

export default component.exports